export default function ComputeReadableDuration(durationMs:number) {
  let TimeString = ""
  let Milliseconds = Math.floor(durationMs)
  let Seconds = Math.floor(durationMs / 1000)
  let Minutes = Math.floor((Seconds / 60))
  let Hours = Math.floor((Minutes / 60))
  let Days = Math.floor(Hours / 24)

  Seconds = Seconds % 60
  Minutes = Minutes % 60
  Hours = Hours % 24
  Days = Days % 24
  if (Days > 0) { TimeString += `${Days}D ` }
  if (Hours > 0) { TimeString += `${Hours}h ` }
  if (Minutes > 0) { TimeString += `${Minutes}min ` }
  if (Seconds > 0) { TimeString += `${Seconds}s ` }
  else{TimeString += `${Milliseconds}ms `}
  
  return TimeString
}